import React from 'react';
import { Layout } from '../components/Layout';

export function Disclosures() {
  return (
    <Layout>
      {/* Header */}
      <section className="bg-gradient-to-br from-primary-600 to-primary-800 text-white py-16">
        <div className="container mx-auto px-4 max-w-6xl">
          <h1 className="text-5xl font-bold mb-4">Disclosures</h1>
          <p className="text-xl text-blue-100">
            Important regulatory disclosures and information
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="prose prose-lg max-w-none">
            {/* Pre-Registration Notice */}
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mt-0 mb-4">
                Pre-Registration Notice
              </h2>
              <p className="mb-0">
                AOK Financial Inc. is currently in the process of registering as a broker-dealer with the Securities and Exchange Commission (SEC) and applying for membership with the Financial Industry Regulatory Authority (FINRA). Until registration is complete, AOK Financial operates under a clearing agreement with RQD, a registered FINRA/SIPC member firm.
              </p>
            </div>

            <h2>Broker-Dealer Information</h2>
            <p>
              <strong>Company Name:</strong> AOK Financial Inc.<br />
              <strong>SEC Registration:</strong> In Progress<br />
              <strong>FINRA Membership:</strong> Application Pending<br />
              <strong>Clearing Firm:</strong> RQD (FINRA/SIPC Member)
            </p>

            <h2>BrokerCheck</h2>
            <p>
              Once registration is complete, you will be able to check AOK Financial's background on FINRA's BrokerCheck at{' '}
              <a
                href="https://brokercheck.finra.org"
                target="_blank"
                rel="noopener noreferrer"
                className="text-accent-600 hover:text-accent-700"
              >
                brokercheck.finra.org
              </a>.
            </p>

            <h2>Customer Relationship Summary (Form CRS)</h2>
            <p>
              Form CRS will be available once registration is complete. This document will provide key information about the types of client relationships and services we offer, fees, costs, conflicts of interest, and disciplinary history.
            </p>

            <h2>Business Continuity Plan (BCP) Summary</h2>
            <p>
              AOK Financial maintains a Business Continuity Plan to ensure the firm can continue to serve customers in the event of a significant business disruption. Our plan addresses:
            </p>
            <ul>
              <li>Data backup and recovery procedures</li>
              <li>Alternative communication methods with customers and employees</li>
              <li>Critical business functions and their recovery time objectives</li>
              <li>Financial and operational assessments</li>
            </ul>

            <h2>Rule 606 - Order Routing Disclosure</h2>
            <p>
              Pursuant to SEC Rule 606, broker-dealers are required to disclose the venues to which they route customer orders for execution and provide information about order routing practices. This information will be made available quarterly once operations commence.
            </p>

            <h2>Payment for Order Flow (PFOF) Disclosure</h2>
            <p>
              AOK Financial does not currently receive payment for order flow. We route orders to venues based on best execution principles, considering price improvement, speed of execution, and likelihood of execution. Should this practice change, we will provide appropriate disclosures.
            </p>

            <h2>Important Risk Disclosures</h2>
            <p>
              Investing in securities involves risk, including possible loss of principal. Customers should carefully consider their investment objectives, risk tolerance, and time horizon before investing.
            </p>
            <p>
              <strong>Extended Hours Trading:</strong> Trading outside of regular market hours (9:30 AM - 4:00 PM ET) carries additional risks including lower liquidity, higher volatility, and wider bid-ask spreads.
            </p>
            <p>
              <strong>Fractional Shares:</strong> Fractional shares may have limited liquidity and may be more difficult to trade than whole shares. Fractional shares are not transferable and may need to be liquidated or completed to whole shares when transferring to another broker.
            </p>

            <h2>Contact Information</h2>
            <p>
              For questions about these disclosures or to request additional information, please contact us at{' '}
              <a href="mailto:info@aokfin.com" className="text-accent-600 hover:text-accent-700">
                info@aokfin.com
              </a>.
            </p>

            <div className="mt-8 text-sm text-gray-600">
              <p>
                <em>Last Updated: January 2026</em>
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
